import { render, staticRenderFns } from "./SelectSales.vue?vue&type=template&id=2d5fdabb&"
import script from "./SelectSales.vue?vue&type=script&lang=ts&"
export * from "./SelectSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5fdabb')) {
      api.createRecord('2d5fdabb', component.options)
    } else {
      api.reload('2d5fdabb', component.options)
    }
    module.hot.accept("./SelectSales.vue?vue&type=template&id=2d5fdabb&", function () {
      api.rerender('2d5fdabb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectSales.vue"
export default component.exports